import React from 'react';
import Missions from '../components/Missions';

const MissionsPage = () => (
  <div>
    <Missions />
  </div>
);

export default MissionsPage;
